import React from "react";
import FormOne from "../contact/FormOne";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";

const AboutOne = () => {
  return (
    <section className="section section-padding-equal bg-color-light">
      <div className="container">
        <div className="row align-items-center">
          {/* Content Section - Left to Right Animation */}
          <motion.div
            className="col-lg-6"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }} // Set to true if you only want animation once
            transition={{ duration: 0.6 }}
          >
            <div className="about-us">
              <div className="section-heading heading-left mb-0">
                <span className="subtitle1">About Us</span>
                <h2 className="title mb--40">Who We Are</h2>
                <p className="truncate-mobile">
                  For over 19 years, UCWF has been a trusted leader in the UAE’s
                  facilities management sector, providing comprehensive
                  solutions tailored to diverse operational needs. Our
                  commitment to transparent communication and collaboration
                  ensures a deep understanding of our clients’ specific
                  requirements, allowing us to deliver seamless, high-quality
                  facility management services. Whether managing large-scale,
                  complex operations or catering to smaller, specialized
                  businesses, we offer end-to-end solutions designed to maintain
                  facilities at optimal performance levels. Our specialized
                  services enable clients to consolidate all their maintenance
                  needs under one provider, enhancing efficiency and reducing
                  costs. Through the seamless integration of budgeting,
                  communication, and accountability, we provide clarity and
                  peace of mind. Additionally, our 24/7 emergency response
                  service guarantees that skilled engineers are always available
                  to deliver prompt, reliable support.
                </p>
              </div>
            </div>
            <Link to="/who-we-are" className="more-btn">
              Learn more <FaAngleRight />
            </Link>
          </motion.div>

          {/* Form Section - Right to Left Animation */}
          <motion.div
            className="col-xl-5 col-lg-6 offset-xl-1"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }} // Set to true if you only want animation once
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="contact-form-box">
              <h3 className="title h3 noMargin">Get in Touch with US</h3>
              {/* Looking for Jobs? Only "Click Here" should be a link */}
              <p className="mb-3">
                Looking for Jobs?{" "}
                <Link to="/careers" className="link-primary">Click Here</Link>
              </p>
             
              <FormOne />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutOne;
